import React, { FC } from 'react';
import { Alert, AlertColor, AlertTitle, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

type InvoiceProcessingErrorProps = {
    message: string;
    // 'error' for a failed (ERROR) invoice; 'warning' for EXTERNAL_INVOICE_ERROR, where the
    // invoice is delivered and only its Fortnox attachment is missing (DD-3504).
    severity?: AlertColor;
    titleKey?: string;
};

// Shows why an invoice ended up in ERROR (the stored processingErrorMessage). The message may
// span several lines, e.g. one validation rule per line, so it is rendered pre-wrapped instead
// of collapsed into one paragraph.
const InvoiceProcessingError: FC<InvoiceProcessingErrorProps> = ({
    message,
    severity = 'error',
    titleKey = 'invoices:INVOICE_PROCESSING_ERROR_REASON',
}: InvoiceProcessingErrorProps) => {
    const { t: translate } = useTranslation(['invoices']);

    return (
        <Box mb={1}>
            <Alert severity={severity} sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                <AlertTitle>{translate(titleKey)}</AlertTitle>
                {message}
            </Alert>
        </Box>
    );
};

export default InvoiceProcessingError;
